export default __webpack_public_path__ + "static/media/bridge.152aea91.png";